import React from 'react'
import { 
    Tooltip,IconButton
    } from '@mui/material';

import DehazeIcon from '@mui/icons-material/Dehaze';

const ExportAllButton = ({...props}) => {

    const { handleExportAll, packageId, userId} = props;

    return (
        <Tooltip title="Export All" onClick={e => handleExportAll(e, packageId, userId)}>
            <IconButton aria-label="exportAll" size="large">
                <DehazeIcon />
            </IconButton>
        </Tooltip>
    );
}

export default ExportAllButton;